import { useMemo, useState } from 'react'
import { zerlege, type Begriff } from '@/core/begriffe'
import { useSettings } from './settings'

export interface MitBegriffenProps {
  text: string
  className?: string
  /** Für Prüfungen: die Marke des Absatzes. */
  testid?: string
  /** Für den Binnenbereich: der Text ist deutsch, auch wenn die Oberfläche englisch ist. */
  lang?: string
}

/**
 * Ein Absatz, in dem die Fachwörter sich selbst erklären.
 *
 * Angetippt klappt unter dem Absatz eine Erklärung auf, zwei Sätze lang. Das ist die
 * kleinste Form, die hilft: keine Fußnote, die den Satz zerreißt, kein Glossar, das man
 * erst finden muss, und kein Tooltip, den auf dem Telefon niemand trifft.
 */
export function MitBegriffen({ text, className, lang, testid }: MitBegriffenProps) {
  const { lang: sprache } = useSettings()
  const [offen, setOffen] = useState<Begriff | undefined>()
  const stuecke = useMemo(() => zerlege(text), [text])

  return (
    <>
      <p className={className} lang={lang} data-testid={testid}>
        {stuecke.map((stueck, i) =>
          stueck.begriff ? (
            <button
              key={i}
              type="button"
              className="begriff"
              data-begriff={stueck.begriff.wort}
              aria-expanded={offen?.wort === stueck.begriff.wort}
              onClick={() => setOffen(offen?.wort === stueck.begriff!.wort ? undefined : stueck.begriff)}
            >
              {stueck.text}
            </button>
          ) : (
            <span key={i}>{stueck.text}</span>
          ),
        )}
      </p>
      {offen && (
        <p className="begriff__erklaerung" data-testid="begriff-erklaerung" data-wort={offen.wort}>
          <strong>{offen.wort}</strong> {offen.erklaerung[sprache]}
        </p>
      )}
    </>
  )
}
